import { useUrl } from './urlData';
import {
  REGION_MODE,
  environmentData,
  OpenType,
  BusinessType
} from '../../utils';
// import { ProductSelectType } from '@support/utils';

export const googleMapKey = 'AIzaSyAEN_-M3sOvvAyrCnvlaGhK0p9onZjH-ac';

export const questionUrl =
  'https://hero.ninebot.com/#/view?pageKey=E15JMlYELB0rlkwn9Amu&language=en';

interface customConfig {
  name: string;
  tips: string;
  imgM: string;
  iconPc: string;
  buttonText: string;
  openType: OpenType;
  openUrl?: string;
  show?: number; //0不显示，1显示
  query?: object; //query参数
}

const {
  Consumer,
  Professional,
  Solutions,
  PowerSports,
  Robotics,
  RoboticMower,
  CubeSeries,
  Support,
  SegwayRobotics,
  NineBotApp,
  NineBotSupport,
  ServiceNetworkPC,
  ServiceNetworkM,
  NinebotAccessoriesPrice,
  NinebotCard,
  dealer_service_request,
  serviceCenter,
  serviceNetwork,
  accessoryPrices,
  NinebotMailRepair
} = useUrl();

function getSiteList() {
  const data: any = {
    // 国内站点
    cn: [{ country: 'cn', lang: 'zh' }],
    // 海外站点
    us: [
      { country: 'us', lang: 'en' },
      { country: 'eu', lang: 'en' },
      { country: 'it', lang: 'it' },
      { country: 'de', lang: 'de' },
      { country: 'es', lang: 'es' },
      { country: 'uk', lang: 'en' },
      { country: 'fr', lang: 'fr' },
      { country: 'ap', lang: 'en' },
      { country: 'au', lang: 'en' },
      { country: 'tr', lang: 'tr' },
      { country: 'ru', lang: 'ru' },
    ]
  };
  return data[REGION_MODE];
}

export function useLocalData() {
  return {
    email: [
      {
        name: 'Segway Store orders:',
        email: 'store@segway.com'
      },
      {
        name: 'Vehicle Services:',
        email: 'service@ninebot.com'
      },
      {
        name: 'European customers:',
        email: 'info@segway.eu.com'
      },
      {
        name: 'Indiegogo Crowdfunding:',
        email: 'wecare@segway.com'
      }
    ],
    noteAndFAQs: [
      {
        title: 'selfRepair.tips',
        content: 'selfRepair.tips_content',
        img: 'ic_note1',
        imgPc: 'repair-step1'
      },
      {
        title: 'selfRepair.please_order_parts_official_store',
        content: 'selfRepair.please_order_parts_official_store_content',
        img: 'ic_note2',
        imgPc: 'repair-step2'
      },
      {
        title: 'selfRepair.please_read_repair_guide_carefully',
        content: 'selfRepair.please_read_repair_guide_carefully_content',
        img: 'ic_note3',
        imgPc: 'repair-step3'
      },
      {
        title: 'selfRepair.repair_your_vehicle',
        content: 'selfRepair.repair_your_vehicle_content',
        img: 'ic_note4',
        imgPc: 'repair-step4'
      }
    ],
    vehicleArea: {
      1: '车把部分',
      2: '立管部分',
      3: '前轮部分',
      4: '车体部分',
      5: '后轮部分',
      6: '腿控部分',
      7: '车轮部分',
      8: '车体部分',
      9: '前舱部分',
      10: '前车架部分',
      11: '后车架部分',
      12: '平衡车部分',
      13: '其它部分',
      14: '其它部分',
      15: '其它部分'
    },
    repairQA: [
      {
        title: 'onlineRepair.suc_long_question',
        content: 'onlineRepair.suc_long_answer'
      },
      {
        title: 'onlineRepair.suc_pay_question',
        content: 'onlineRepair.suc_pay_answer'
      },
      {
        title: 'onlineRepair.suc_howpay_question',
        content: 'onlineRepair.suc_howpay_answer'
      },
      {
        title: 'onlineRepair.suc_privacy_question',
        content: 'onlineRepair.suc_privacy_answer'
      },
      {
        title: 'onlineRepair.suc_sending_question',
        content: 'onlineRepair.suc_sending_answer'
      },
      {
        title: 'onlineRepair.suc_product_question',
        content: 'onlineRepair.suc_product_answer'
      },
      {
        title: 'onlineRepair.suc_progress_question',
        content: 'onlineRepair.suc_progress_answer'
      }
    ],
    siteList: getSiteList(),
    ...allLocalData(environmentData.country),
    linkList: [
      { name: 'mailRepair.name', code: 'linkName' },
      { name: 'mailRepair.phone', code: 'phoneNumber' },
      { name: 'mailRepair.email', code: 'mail' },
      { name: 'mailRepair.country_state_city', code: 'city' },
      // { name: 'mailRepair.postal_code', code: 'zIP' },
      { name: 'mailRepair.return_address', code: 'recevingStreet' },
      { name: 'mailRepair.address', code: 'street' }
    ]
  };
}
function allLocalData(country: string) {
  const config: any = {
    cn: {
      lang: 'zh',
      menu: [
        {
          name: '滑板车',
          clickTypeName: '滑板车',
          url: 'https://www.ninebot.com/ekickscooter.html ',
          imgM: 'ic_scooter',
          openType: OpenType.link
        },
        {
          name: '电动车',
          clickTypeName: '电动车',
          url: 'https://www.ninebot.com/escooter.html',
          imgM: 'ic_electro',
          openType: OpenType.link
        },
        {
          name: '平衡车',
          clickTypeName: '平衡车',
          url: 'https://www.ninebot.com/self-balancing.html',
          imgM: 'ic_balance',
          openType: OpenType.link
        },
        'content-divider',
        {
          name: 'APP',
          clickTypeName: 'APP',
          url: 'https://www.ninebot.com/app.html',
          openType: OpenType.link
        },
        {
          name: 'Segway旗下',
          children: [
            {
              name: '滑板车',
              clickTypeName: 'Segway旗下-滑板车',
              url: 'https://www.ninebot.com/segway/ekickscooter.html',
              openType: OpenType.link
            },
            {
              name: '电动车',
              clickTypeName: 'Segway旗下-电动车',
              url: 'https://www.ninebot.com/segway/escooter/products/xyber.html',
              openType: OpenType.link
            },
            {
              name: '卡丁车',
              clickTypeName: 'Segway旗下-卡丁车',
              url: 'https://www.ninebot.com/segway/gokart.html',
              openType: OpenType.link
            },

            {
              name: '全地形车',
              clickTypeName: 'Segway旗下-全地形车',
              url: 'https://cn.segwaypowersports.com/',
              openType: OpenType.link
            },
            {
              name: '储能电源',
              clickTypeName: 'Segway旗下-储能电源',
              url: 'https://www.ninebot.com/segway/power-station/products.html',
              openType: OpenType.link
            },
            // {
            //   name: '割草机器人',
            //   url: 'https://navimow.segway.com/us/',
            //   openType: OpenType.link
            // },
            {
              name: '服务机器人',
              clickTypeName: 'Segway旗下-服务机器人',
              url: 'https://www.segwayrobotics.com/#/index',
              openType: OpenType.link
            },
            {
              name: '商用出行',
              clickTypeName: 'Segway旗下-商用出行',
              url: 'https://b2b.segway.com/',
              openType: OpenType.link
            }
          ]
        },
        {
          name: '关于我们',
          children: [
            {
              name: '公司介绍',
              clickTypeName: '公司介绍',
              url: 'https://www.ninebot.com/explore/about-us.html',
              openType: OpenType.link
            },
            {
              name: '资讯中心',
              clickTypeName: '资讯中心',
              url: 'https://www.ninebot.com/explore/news.html',
              openType: OpenType.link
            },
            {
              name: '投资者关系',
              clickTypeName: '投资者关系',
              url: 'https://www.ninebot.com/explore/investor.html',
              openType: OpenType.link
            },
            {
              name: '联系我们',
              clickTypeName: '联系我们',
              url: 'https://www.ninebot.com/explore/contact-us.html',
              openType: OpenType.link
            }
          ]
        },
        {
          name: '服务支持',
          clickTypeName: '服务支持',
          url: NineBotSupport,
          openType: OpenType.backHome
        }
      ],
      hotServer: [
        {
          name: 'support.frequently_asked_question', //常见问题
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.policy_detail', // 服务政策
          tips: 'support.query_product_policy',
          img: 'ic_policy_detail_hot',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1,
          businessType: BusinessType.policyDetail
        },
        {
          name: 'support.instruction', //产品资料
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.service_network', // 服务网点，暂时没有businessType
          tips: 'support.service_network_info',
          img: 'ic_service_network',
          iconPc: 'ic_service_center',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: serviceNetwork,
          mUrl: serviceNetwork
        }
      ],
      // 锚点
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      homeMoreServices: [
        // 配件价格
        {
          name: 'support.nb_accessoriesPrice',
          tips: 'support.nb_accessoriesPrice_tips',
          img: 'ic_accessories_price',
          iconPc: 'ic_accessories_price',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: accessoryPrices,
          mUrl: accessoryPrices,
          show: 1
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          icon: 'icon-policy-detail-ver',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      vehicleMoreServices: [
        // 车辆页面增加配件价格入口
        {
          name: 'support.nb_accessoriesPrice',
          tips: 'support.nb_accessoriesPrice_tips',
          img: 'ic_accessories_price_m',
          iconPc: 'ic_accessories_price',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: accessoryPrices,
          mUrl: accessoryPrices,
          show: 1
        },
        {
          name: 'support.service_network',
          tips: 'support.service_network_info',
          img: 'ic_service_network_more',
          iconPc: 'ic_service_center',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: serviceNetwork,
          mUrl: serviceNetwork,
          show: 1
        }
      ],
      vehicleRepair: [],
      // 在线客服
      onlineChat: {
        email: 'service@ninebot.com',
        phone: '400-607-0001',
        phoneDesc: '400-607-0001',
        workTime: '09:00-18:00'
      },
      adConfig: {
        test: {
          pcId: 'iTGTyc',
          mId: 'YNRE2g'
        },
        prod: {
          pcId: '762dQ6',
          mId: 'MVf7N1'
        },
        grey: {
          pcId: 'iTGTyc',
          mId: 'YNRE2g'
        }
      }
    },
    us: {
      lang: 'en',
      menu: [
        {
          name: 'Store',
          url: 'https://store.segway.com/',
          openType: OpenType.link
        },
        {
          name: 'eKickScooter',
          url: 'https://segway.com/ekickscooter.html',
          imgM: 'ic_kickScooter',
          openType: OpenType.link
        },
        {
          name: 'E-Bike',
          url: 'https://segway.com/ebike.html',
          imgM: 'ic_bike',
          openType: OpenType.link
        },
        {
          name: 'GoKart',
          url: 'https://segway.com/gokart.html',
          imgM: 'ic_go_kart',
          openType: OpenType.link
        },
        {
          name: 'Self-Balancing',
          url: 'https://segway.com/self-balancing.html',
          imgM: 'ic_balance',
          openType: OpenType.link
        },
        {
          name: 'Off-Road Vehicle',
          url: 'https://www.segwaypowersports.us/',
          imgM: 'ic_off_road',
          openType: OpenType.link
        },
        'content-divider',
        {
          name: 'Explore',
          children: [
            // {
            //   name: 'Power Station',
            //   url: 'https://segway.com/power-station/products.html',
            //   openType: OpenType.link
            // },
            {
              name: 'About Us',
              url: 'https://segway.com/explore/about-us.html',
              openType: OpenType.link
            },
            {
              name: 'Contact Us',
              url: 'https://segway.com/explore/contact-us.html',
              openType: OpenType.link
            },
            {
              name: 'Newsroom',
              url: 'https://segway.com/explore/news.html',
              openType: OpenType.link
            },
            {
              name: 'APP Download',
              url: 'https://segway.com/app.html',
              openType: OpenType.link
            }
            // {
            //   name: 'Career',
            //   url: 'https://www.segway.com/careers/',
            //   openType: OpenType.link
            // }
          ]
        },
        // {
        //   name: 'Where to buy',
        //   url: 'https://segway.com/store-locator.html',
        //   openType: OpenType.link
        // },
        {
          name: 'Support',
          url: Support,
          openType: OpenType.backHome
        }
      ],
      hotServer: [
        {
          name: 'support.frequently_asked_question', //常见问题
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.spare_parts_repair_video', // 自助维修
          tips: 'support.service_spare_parts_repair_video',
          img: 'icon_video',
          iconPc: 'icon_video',
          openUrl: '',
          mUrl: '',
          buttonText: 'support.view_now',
          openType: OpenType.selfRepair,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.instruction', // 产品资料
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.apply_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.policy_detail', // 服务政策
          tips: 'support.query_product_policy',
          img: 'icon-policy-detail',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.policyDetail
        }
      ],
      // 锚点
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      homeMoreServices: [
        {
          name: 'support.self_repair',
          tips: 'support.self_repair_tips',
          img: 'ic_self_repair',
          iconPc: 'ic_self_repair',
          buttonText: 'support.view_now',
          openUrl: '/selfRepair',
          query: {
            goType: 3
          },
          mUrl: '/vehicleSupport/modelSelect',
          openType: OpenType.innerUrl,
          show: 1,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.service_network',
          tips: 'support.service_network_info',
          img: 'ic_service_network_us',
          iconPc: 'ic_service_center',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: serviceCenter,
          mUrl: serviceCenter,
          show: 1
        },
        {
          name: 'support.dealer_service_request',
          tips: 'support.submit_company_code',
          img: 'ic_dealer_service_request',
          iconPc: 'ic_dealer_service',
          buttonText: 'support.view_now',
          openUrl: dealer_service_request,
          mUrl: dealer_service_request,
          openType: OpenType.innerUrl,
          show: 1
        },
        {
          name: 'support.online_repair',
          tips: 'support.online_repair_tips',
          img: 'ic_online_repair',
          iconPc: 'ic_online_repair',
          openUrl: '/onlineRepair',
          mUrl: '/onlineRepair',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          businessType: BusinessType.onlineRepair
        },
        // 寄修服务
        {
          name: 'mailRepair.service_progress_check',
          tips: 'mailRepair.service_check_progress',
          icon: 'ic_mail_repair_progress',
          img: 'ic_mail_repair_progress',
          iconPc: 'ic_mail_repair_progress',
          buttonText: 'support.view_now',
          openUrl: '/mailRepair',
          mUrl: '/mailRepair',
          openType: OpenType.innerUrl,
          show: 1
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          icon: 'icon-policy-detail-ver',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      vehicleRepair: [
        {
          name: 'vehicleSupport.self_repair',
          tips: 'vehicleSupport.self_repair_tips',
          img: 'ic_self_repair_vehicle',
          iconPc: 'ic_self_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.selfRepair,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.service_network',
          tips: 'support.service_network_info',
          img: 'icon_sv_center',
          iconPc: 'ic_service_center',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: serviceCenter,
          mUrl: serviceCenter,
          show: 1
        },
        {
          name: 'vehicleSupport.online_repair',
          tips: 'vehicleSupport.online_repair_tips',
          img: 'ic_online_repair_vehicle',
          iconPc: 'ic_online_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.onlineRepair,
          openUrl: '/onlineRepair',
          mUrl: '/onlineRepair',
          show: 1
        },
        {
          name: 'mailRepair.service_progress_check',
          tips: 'mailRepair.service_check_progress',
          img: 'ic-m-mail-repair-progress',
          iconPc: 'ic-mail-repair-progress',
          buttonText: 'support.view_now',
          openUrl: '/mailRepair',
          mUrl: '/mailRepair',
          openType: OpenType.innerUrl,
          show: 1
        }
      ],
      // 在线客服
      onlineChat: {
        email: 'technicalsupport@segway.com',
        phone: '18664734929',
        phoneDesc: '1-866-4SEGWAY\n(866-473-4929)',
        workTime: '(5:30-17:00)(PST)'
      },
      adConfig: {
        test: {
          pcId: '4cf2eM',
          mId: 'xoR84K'
        },
        prod: {
          pcId: 'TNxZv3',
          mId: 'XQUG7A'
        },
        grey: {
          pcId: '4cf2eM',
          mId: 'xoR84K'
        }
      }
    },
    eu: {
      lang: 'en',
      menu: [
        {
          name: 'Products',
          url: 'https://eu-en.segway.com/customer-products',
          openType: OpenType.link
        },
        {
          name: 'eScooter/eMoped',
          url: 'https://eu-en.segway.com/escooter-and-emoped',
          openType: OpenType.link
        },
        {
          name: 'Portable Power Station',
          url: 'https://eu-en.segway.com/cubes-series-2',
          openType: OpenType.link
        },
        {
          name: 'Points of Sale',
          url: 'https://eu-en.segway.com/find-a-dealer',
          openType: OpenType.link
        },
        {
          name: 'Robotics',
          url: 'https://navimow.segway.com/global/',
          openType: OpenType.link
        },
        {
          name: 'Support',
          url: Support,
          openType: OpenType.backHome
        }
      ],
      hotServer: [
        {
          name: 'support.frequently_asked_question',
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.spare_parts_repair_video', // 自助维修
          tips: 'support.service_spare_parts_repair_video',
          img: 'icon_video',
          iconPc: 'icon_video',
          openUrl: '',
          mUrl: '',
          buttonText: 'support.view_now',
          openType: OpenType.selfRepair,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.instruction', // 产品资料
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.apply_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'icon-policy-detail',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.policyDetail
        }
      ],
      homeMoreServices: [
        {
          name: 'support.self_repair',
          tips: 'support.self_repair_tips',
          img: 'ic_self_repair',
          iconPc: 'ic_self_repair',
          buttonText: 'support.view_now',
          openUrl: '/selfRepair',
          query: {
            goType: 3
          },
          mUrl: '/vehicleSupport/modelSelect',
          openType: OpenType.innerUrl,
          show: 1,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.online_repair',
          tips: 'support.online_repair_tips',
          img: 'ic_online_repair',
          openUrl: 'https://segway.one-connect.b2x.com/',
          mUrl: 'https://segway.one-connect.b2x.com/',
          iconPc: 'ic_online_repair',
          buttonText: 'support.view_now',
          openType: OpenType.link,
          businessType: BusinessType.onlineRepair
        },
        {
          name: 'support.regulations',
          tips: 'support.regulations_tips',
          img: 'regulations',
          iconPc: 'regulations',
          buttonText: 'support.view_now',
          openUrl: '/regulations',
          mUrl: '/regulations',
          openType: OpenType.innerUrl,
          show: 1
        }
      ],
      // 锚点
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      vehicleMoreServices: [],
      vehicleRepair: [
        {
          name: 'vehicleSupport.self_repair',
          tips: 'vehicleSupport.self_repair_tips',
          img: 'ic_self_repair_vehicle',
          iconPc: 'ic_self_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.selfRepair,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'vehicleSupport.find_dealer',
          tips: 'vehicleSupport.find_dealer_info',
          img: 'icon_sv_center',
          iconPc: 'ic_service_center',
          buttonText: 'vehicleSupport.find_dealer_learn_more',
          openType: OpenType.link,
          openUrl: 'https://eu-en.segway.com/find-a-dealer',
          mUrl: 'https://eu-en.segway.com/find-a-dealer',
          show: 1
        },
        {
          name: 'vehicleSupport.online_repair',
          tips: 'vehicleSupport.online_repair_tips',
          img: 'ic_online_repair_vehicle',
          iconPc: 'ic_online_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.link,
          openUrl: 'https://segway.one-connect.b2x.com/',
          mUrl: 'https://segway.one-connect.b2x.com/',
          show: 1
        }
      ],
      // 在线客服
      onlineChat: {
        email: 'technicalsupport@segway.com',
        phone: '+31202140274',
        phoneDesc: '+31 202140274',
        workTime: 'Monday-Friday(9:00-18:00)(CET)\nEU Landline Number'
      },
      adConfig: {
        test: {
          pcId: 'hkg0PI',
          mId: 'lSHKy8'
        },
        prod: {
          pcId: 'tAx1uw',
          mId: 'ILjudS'
        },
        grey: {
          pcId: 'hkg0PI',
          mId: 'lSHKy8'
        }
      }
    },
    de: {
      lang: 'de',
      menu: [
        {
          name: 'Produkte',
          url: 'https://de-de.segway.com/customer-products',
          openType: OpenType.link
        },
        {
          name: 'e-Roller/eMofa',
          url: 'https://de-de.segway.com/escooter-and-emoped',
          openType: OpenType.link
        },
        // {
        //   name: 'Portable Power Station',
        //   url: 'https://de-de.segway.com/cubes-series-2',
        //   openType: OpenType.link
        // },
        {
          name: 'Robotic Mower',
          url: 'https://navimow.segway.com/global/',
          openType: OpenType.link
        },
        {
          name: 'Geschäftsmöglichkeiten',
          url: 'https://de-de.segway.com/gesch%C3%A4ftsm%C3%B6glichkeiten',
          openType: OpenType.link
        },
        {
          name: 'Über uns',
          url: 'https://de-de.segway.com/about-the-brand',
          openType: OpenType.link
        },
        {
          name: 'Kundendienst',
          url: Support,
          openType: OpenType.backHome
        }
      ],
      hotServer: [
        {
          name: 'support.frequently_asked_question',
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.spare_parts_repair_video', // 自助维修
          tips: 'support.service_spare_parts_repair_video',
          img: 'icon_video',
          iconPc: 'icon_video',
          openUrl: '',
          mUrl: '',
          buttonText: 'support.view_now',
          openType: OpenType.selfRepair,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.apply_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'icon-policy-detail',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.policyDetail
        }
      ],
      homeMoreServices: [
        {
          name: 'support.self_repair',
          tips: 'support.self_repair_tips',
          img: 'ic_self_repair',
          iconPc: 'ic_self_repair',
          buttonText: 'support.view_now',
          openUrl: '/selfRepair',
          query: {
            goType: 3
          },
          mUrl: '/vehicleSupport/modelSelect',
          openType: OpenType.innerUrl,
          show: 1,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.online_repair',
          tips: 'support.online_repair_tips',
          img: 'ic_online_repair',
          openUrl: 'https://segway-de.one-connect.b2x.com/',
          mUrl: 'https://segway-de.one-connect.b2x.com/',
          iconPc: 'ic_online_repair',
          buttonText: 'support.view_now',
          openType: OpenType.link,
          businessType: BusinessType.onlineRepair
        },
        {
          name: 'support.regulations',
          tips: 'support.regulations_tips',
          img: 'regulations',
          iconPc: 'regulations',
          buttonText: 'support.view_now',
          openUrl: 'https://de-de.segway.com/gesetzgebung',
          mUrl: 'https://de-de.segway.com/gesetzgebung',
          openType: OpenType.link,
          show: 1
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      // 锚点
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      vehicleMoreServices: [],
      vehicleRepair: [
        {
          name: 'vehicleSupport.self_repair',
          tips: 'vehicleSupport.self_repair_tips',
          img: 'ic_self_repair_vehicle',
          iconPc: 'ic_self_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.selfRepair,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'vehicleSupport.find_dealer',
          tips: 'vehicleSupport.find_dealer_info',
          img: 'icon_sv_center',
          iconPc: 'ic_service_center',
          buttonText: 'vehicleSupport.find_dealer_learn_more',
          openType: OpenType.link,
          openUrl: 'https://de-de.segway.com/find-a-dealer',
          mUrl: 'https://de-de.segway.com/find-a-dealer',
          show: 1
        },
        {
          name: 'vehicleSupport.online_repair',
          tips: 'vehicleSupport.online_repair_tips',
          img: 'ic_online_repair_vehicle',
          iconPc: 'ic_online_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.link,
          openUrl: 'https://segway-de.one-connect.b2x.com/',
          mUrl: 'https://segway-de.one-connect.b2x.com/',
          show: 1
        }
      ],
      // 在线客服
      onlineChat: {
        // email: 'segway.de@sertec360.com',
        // phone: '+494085568021',
        // phoneDesc: '+49 4085568021',
        // workTime: '(5:30-17:00)(PST)'
        email: 'support-de@segway.eu.com',
        phone: '+498001888001',
        phoneDesc: '+49 8001888001',
        workTime: 'Montag–Freitag 9:00–18:00(CET)'
      },
      adConfig: {
        test: {
          pcId: 'O0vrNx',
          mId: 'KPaLHx'
        },
        prod: {
          pcId: 'CDSYEZ',
          mId: 'Cs7Le1'
        },
        grey: {
          pcId: 'O0vrNx',
          mId: 'KPaLHx'
        }
      }
    },
    es: {
      lang: 'es',
      menu: [
        {
          name: 'Productos',
          url: 'https://es-es.segway.com/customer-products',
          openType: OpenType.link
        },
        {
          name: 'eScooters',
          url: 'https://es-es.segway.com/escooter-and-emoped',
          openType: OpenType.link
        },
        {
          name: 'Estación de carga portátil',
          url: 'https://es-es.segway.com/cubes-series-2',
          openType: OpenType.link
        },
        {
          name: 'Robot cortacésped',
          url: 'http://navimow.segway.com/',
          openType: OpenType.link
        },
        {
          name: 'B2B',
          url: 'https://b2b.segway.com/',
          openType: OpenType.link
        },
        {
          name: 'Acerca de nosotros',
          url: 'https://es-es.segway.com/about-the-brand',
          openType: OpenType.link
        },
        {
          name: 'Soporte',
          url: Support,
          openType: OpenType.backHome
        }
      ],
      hotServer: [
        {
          name: 'support.frequently_asked_question',
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.spare_parts_repair_video', // 自助维修
          tips: 'support.service_spare_parts_repair_video',
          img: 'icon_video',
          iconPc: 'icon_video',
          openUrl: '',
          mUrl: '',
          buttonText: 'support.view_now',
          openType: OpenType.selfRepair,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.apply_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'icon-policy-detail',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.policyDetail
        }
      ],
      homeMoreServices: [
        {
          name: 'support.self_repair',
          tips: 'support.self_repair_tips',
          img: 'ic_self_repair',
          iconPc: 'ic_self_repair',
          buttonText: 'support.view_now',
          openUrl: '/selfRepair',
          query: {
            goType: 3
          },
          mUrl: '/vehicleSupport/modelSelect',
          openType: OpenType.innerUrl,
          show: 1,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.online_repair',
          tips: 'support.online_repair_tips',
          img: 'ic_online_repair',
          openUrl: 'https://segway-espt.one-connect.b2x.com/',
          mUrl: 'https://segway-espt.one-connect.b2x.com/',
          iconPc: 'ic_online_repair',
          buttonText: 'support.view_now',
          openType: OpenType.link,
          businessType: BusinessType.onlineRepair
        },
        {
          name: 'support.regulations',
          tips: 'support.regulations_tips',
          img: 'regulations',
          iconPc: 'regulations',
          buttonText: 'support.view_now',
          openUrl: 'https://es-es.segway.com/normativas-nacionales',
          mUrl: 'https://es-es.segway.com/normativas-nacionales',
          openType: OpenType.link,
          show: 1
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      // 锚点
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      vehicleMoreServices: [],
      vehicleRepair: [
        {
          name: 'vehicleSupport.self_repair',
          tips: 'vehicleSupport.self_repair_tips',
          img: 'ic_self_repair_vehicle',
          iconPc: 'ic_self_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.selfRepair,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'vehicleSupport.find_dealer',
          tips: 'vehicleSupport.find_dealer_info',
          img: 'icon_sv_center',
          iconPc: 'ic_service_center',
          buttonText: 'vehicleSupport.find_dealer_learn_more',
          openType: OpenType.link,
          openUrl: 'https://es-es.segway.com/find-a-dealer',
          mUrl: 'https://es-es.segway.com/find-a-dealer',
          show: 1
        },
        {
          name: 'vehicleSupport.online_repair',
          tips: 'vehicleSupport.online_repair_tips',
          img: 'ic_online_repair_vehicle',
          iconPc: 'ic_online_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.link,
          openUrl: 'https://segway-espt.one-connect.b2x.com/',
          mUrl: 'https://segway-espt.one-connect.b2x.com/',
          show: 1
        }
      ],
      // 在线客服
      onlineChat: {
        // email: 'segway.es@sertec360.com',
        // phone: '+34931222868',
        // phoneDesc: '+34 931222868',
        // workTime: '(5:30-17:00)(PST)'
        email: 'support-es@segway.eu.com',
        phone: '+34900993418',
        phoneDesc: '+34 900993418',
        workTime: 'Lunes–Viernes 9:00–18:00(CET)'
      },
      adConfig: {
        test: {
          pcId: 'CZo0CG',
          mId: '5zeBGM'
        },
        prod: {
          pcId: 'OT8fHB',
          mId: 'xQKrYh'
        },
        grey: {
          pcId: 'CZo0CG',
          mId: '5zeBGM'
        }
      }
    },
    it: {
      lang: 'it',
      menu: [
        {
          name: 'Prodotti',
          url: 'https://it-it.segway.com/customer-products',
          openType: OpenType.link
        },
        {
          name: 'Portable Power Station',
          url: 'https://it-it.segway.com/cubes-series-2',
          openType: OpenType.link
        },
        {
          name: 'Robotic Mower',
          url: 'https://navimow.segway.com/global/',
          openType: OpenType.link
        },
        {
          name: 'Chi siamo',
          url: 'https://it-it.segway.com/about-the-brand',
          openType: OpenType.link
        },
        {
          name: 'Assistenza',
          url: Support,
          openType: OpenType.backHome
        }
      ],
      hotServer: [
        {
          name: 'support.frequently_asked_question',
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.spare_parts_repair_video', // 自助维修
          tips: 'support.service_spare_parts_repair_video',
          img: 'icon_video',
          iconPc: 'icon_video',
          openUrl: '',
          mUrl: '',
          buttonText: 'support.view_now',
          openType: OpenType.selfRepair,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.apply_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'icon-policy-detail',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.policyDetail
        }
      ],
      homeMoreServices: [
        {
          name: 'support.self_repair',
          tips: 'support.self_repair_tips',
          img: 'ic_self_repair',
          iconPc: 'ic_self_repair',
          buttonText: 'support.view_now',
          openUrl: '/selfRepair',
          query: {
            goType: 3
          },
          mUrl: '/vehicleSupport/modelSelect',
          openType: OpenType.innerUrl,
          show: 1,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.online_repair',
          tips: 'support.online_repair_tips',
          img: 'ic_online_repair',
          openUrl: 'https://segway.one-connect.b2x.com/',
          mUrl: 'https://segway.one-connect.b2x.com/',
          iconPc: 'ic_online_repair',
          buttonText: 'support.view_now',
          openType: OpenType.link,
          businessType: BusinessType.onlineRepair
        },
        {
          name: 'support.regulations',
          tips: 'support.regulations_tips',
          img: 'regulations',
          iconPc: 'regulations',
          buttonText: 'support.view_now',
          openUrl: 'https://it-it.segway.com/normative',
          mUrl: 'https://it-it.segway.com/normative',
          openType: OpenType.link,
          show: 1
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      // 锚点
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      vehicleMoreServices: [],
      vehicleRepair: [
        {
          name: 'vehicleSupport.self_repair',
          tips: 'vehicleSupport.self_repair_tips',
          img: 'ic_self_repair_vehicle',
          iconPc: 'ic_self_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.selfRepair,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'vehicleSupport.find_dealer',
          tips: 'vehicleSupport.find_dealer_info',
          img: 'icon_sv_center',
          iconPc: 'ic_service_center',
          buttonText: 'vehicleSupport.find_dealer_learn_more',
          openType: OpenType.link,
          openUrl: 'https://it-it.segway.com/find-a-dealer',
          mUrl: 'https://it-it.segway.com/find-a-dealer',
          show: 1
        },
        {
          name: 'vehicleSupport.online_repair',
          tips: 'vehicleSupport.online_repair_tips',
          img: 'ic_online_repair_vehicle',
          iconPc: 'ic_online_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.link,
          openUrl: 'https://segway.one-connect.b2x.com/',
          mUrl: 'https://segway.one-connect.b2x.com/',
          show: 1
        }
      ],
      // 在线客服
      onlineChat: {
        // email: 'segway.it@sertec360.com',
        // phone: '+390230416066',
        // phoneDesc: '+39 0230416066',
        // workTime: '(5:30-17:00)(PST)'
        email: 'support-it@segway.eu.com',
        phone: '+39800684900',
        phoneDesc: '+39 800684900',
        workTime: 'Lunedì–Venerdì 9:00–18:00(CET)'
      },
      adConfig: {
        test: {
          pcId: 'GdLC9V',
          mId: 'AJisiM'
        },
        prod: {
          pcId: 'OLcDGc',
          mId: 'nSviU0'
        },
        grey: {
          pcId: 'GdLC9V',
          mId: 'AJisiM'
        }
      }
    },
    uk: {
      lang: 'en',
      menu: [
        {
          name: 'Products',
          url: 'https://uk-en.segway.com/',
          openType: OpenType.link
        },
        {
          name: 'Security and Tourism',
          url: 'https://uk-en.segway.com/personal-transporter',
          openType: OpenType.link
        },
        {
          name: 'Points of Sale',
          url: 'https://uk-en.segway.com/find-a-dealer',
          openType: OpenType.link
        },
        {
          name: 'Support',
          url: Support,
          openType: OpenType.backHome
        }
      ],
      hotServer: [
        {
          name: 'support.frequently_asked_question',
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.spare_parts_repair_video', // 自助维修
          tips: 'support.service_spare_parts_repair_video',
          img: 'icon_video',
          iconPc: 'icon_video',
          openUrl: '',
          mUrl: '',
          buttonText: 'support.view_now',
          openType: OpenType.selfRepair,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.apply_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'icon-policy-detail',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.policyDetail
        }
      ],
      homeMoreServices: [
        {
          name: 'support.self_repair',
          tips: 'support.self_repair_tips',
          img: 'ic_self_repair',
          iconPc: 'ic_self_repair',
          buttonText: 'support.view_now',
          openUrl: '/selfRepair',
          query: {
            goType: 3
          },
          mUrl: '/vehicleSupport/modelSelect',
          openType: OpenType.innerUrl,
          show: 1,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.online_repair',
          tips: 'support.online_repair_tips',
          img: 'ic_online_repair',
          openUrl: 'https://segway.one-connect.b2x.com/',
          mUrl: 'https://segway.one-connect.b2x.com/',
          iconPc: 'ic_online_repair',
          buttonText: 'support.view_now',
          openType: OpenType.link,
          businessType: BusinessType.onlineRepair
        },
        {
          name: 'support.regulations',
          tips: 'support.regulations_tips',
          img: 'regulations',
          iconPc: 'regulations',
          buttonText: 'support.view_now',
          openUrl: 'https://uk-en.segway.com/regulations-1',
          mUrl: 'https://uk-en.segway.com/regulations-1',
          openType: OpenType.link,
          show: 1
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      // 锚点
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      vehicleMoreServices: [],
      vehicleRepair: [
        {
          name: 'vehicleSupport.self_repair',
          tips: 'vehicleSupport.self_repair_tips',
          img: 'ic_self_repair_vehicle',
          iconPc: 'ic_self_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.selfRepair,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'vehicleSupport.find_dealer',
          tips: 'vehicleSupport.find_dealer_info',
          img: 'icon_sv_center',
          iconPc: 'ic_service_center',
          buttonText: 'vehicleSupport.find_dealer_learn_more',
          openType: OpenType.link,
          openUrl: 'https://uk-en.segway.com/find-a-dealer',
          mUrl: 'https://uk-en.segway.com/find-a-dealer',
          show: 1
        },
        {
          name: 'vehicleSupport.online_repair',
          tips: 'vehicleSupport.online_repair_tips',
          img: 'ic_online_repair_vehicle',
          iconPc: 'ic_online_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.link,
          openUrl: 'https://segway.one-connect.b2x.com/',
          mUrl: 'https://segway.one-connect.b2x.com/',
          show: 1
        }
      ],
      // 在线客服
      onlineChat: {
        email: 'support-uk@segway.eu.com',
        phone: '+4408000554851',
        phoneDesc: '+44 08000554851',
        workTime: 'Mon-Fri 9:00-18:00(CET)'
      },
      adConfig: {
        test: {
          pcId: 'nT19b3',
          mId: 'SUpJHP'
        },
        prod: {
          pcId: 'tc32s1',
          mId: 'MIcU18'
        },
        grey: {
          pcId: 'nT19b3',
          mId: 'SUpJHP'
        }
      }
    },
    fr: {
      lang: 'fr',
      menu: [
        {
          name: 'Produits',
          url: 'https://fr-fr.segway.com/',
          openType: OpenType.link
        },
        {
          name: 'Portable Power Station',
          url: 'https://fr-fr.segway.com/cubes-series-2',
          openType: OpenType.link
        },
        {
          name: 'eScooter/eMob',
          url: 'https://fr-fr.segway.com/escooter-and-emoped',
          openType: OpenType.link
        },
        {
          name: 'Robotic Mower',
          url: 'https://navimow.segway.com/global/',
          openType: OpenType.link
        },
        {
          name: 'Points de Vente',
          url: 'https://fr-fr.segway.com/find-a-dealer',
          openType: OpenType.link
        },
        {
          name: 'Support',
          url: Support,
          openType: OpenType.backHome
        }
      ],
      hotServer: [
        {
          name: 'support.frequently_asked_question',
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.spare_parts_repair_video', // 自助维修
          tips: 'support.service_spare_parts_repair_video',
          img: 'icon_video',
          iconPc: 'icon_video',
          openUrl: '',
          mUrl: '',
          buttonText: 'support.view_now',
          openType: OpenType.selfRepair,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.apply_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'icon-policy-detail',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.policyDetail
        }
      ],
      homeMoreServices: [
        {
          name: 'support.self_repair',
          tips: 'support.self_repair_tips',
          img: 'ic_self_repair',
          iconPc: 'ic_self_repair',
          buttonText: 'support.view_now',
          openUrl: '/selfRepair',
          query: {
            goType: 3
          },
          mUrl: '/vehicleSupport/modelSelect',
          openType: OpenType.innerUrl,
          show: 1,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.online_repair',
          tips: 'support.online_repair_tips',
          img: 'ic_online_repair',
          openUrl: 'https://segway.one-connect.b2x.com/',
          mUrl: 'https://segway.one-connect.b2x.com/',
          iconPc: 'ic_online_repair',
          buttonText: 'support.view_now',
          openType: OpenType.link,
          businessType: BusinessType.onlineRepair
        },
        {
          name: 'support.regulations',
          tips: 'support.regulations_tips',
          img: 'regulations',
          iconPc: 'regulations',
          buttonText: 'support.view_now',
          openUrl: 'https://fr-fr.segway.com/r%C3%A9glementation',
          mUrl: 'https://fr-fr.segway.com/r%C3%A9glementation',
          openType: OpenType.link,
          show: 1
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      // 锚点
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      vehicleMoreServices: [],
      vehicleRepair: [
        {
          name: 'vehicleSupport.self_repair',
          tips: 'vehicleSupport.self_repair_tips',
          img: 'ic_self_repair_vehicle',
          iconPc: 'ic_self_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.selfRepair,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'vehicleSupport.find_dealer',
          tips: 'vehicleSupport.find_dealer_info',
          img: 'icon_sv_center',
          iconPc: 'ic_service_center',
          buttonText: 'vehicleSupport.find_dealer_learn_more',
          openType: OpenType.link,
          openUrl: 'https://fr-fr.segway.com/find-a-dealer',
          mUrl: 'https://fr-fr.segway.com/find-a-dealer',
          show: 1
        },
        {
          name: 'vehicleSupport.online_repair',
          tips: 'vehicleSupport.online_repair_tips',
          img: 'ic_online_repair_vehicle',
          iconPc: 'ic_online_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.link,
          openUrl: 'https://segway.one-connect.b2x.com/',
          mUrl: 'https://segway.one-connect.b2x.com/',
          show: 1
        }
      ],
      // 在线客服
      onlineChat: {
        email: 'support-fr@segway.eu.com',
        phone: '+330805083547',
        phoneDesc: '+33 0805083547',
        workTime: 'Lun-Ven 9:00-18:00(CET)'
      },
      adConfig: {
        test: {
          pcId: 'PSujMH',
          mId: 'IIYu1d'
        },
        prod: {
          pcId: 'wmrl26',
          mId: 'HfTPty'
        },
        grey: {
          pcId: 'PSujMH',
          mId: 'IIYu1d'
        }
      }
    },
    // 亚太通用
    ap: {
      lang: 'en',
      // 导航延用
      menu: [
        {
          name: 'Products',
          url: 'https://ap-en.segway.com/',
          openType: OpenType.link
        },
        {
          name: 'About us',
          url: 'https://ap-en.segway.com/about-us.html',
          openType: OpenType.link
        },
        {
          name: 'Where to buy',
          url: 'https://ap-en.segway.com/find-a-dealer.html',
          openType: OpenType.link
        },
        // 分割线
        // 'content-divider',
        {
          name: 'Support',
          url: Support,
          openType: OpenType.backHome
        }
      ],
      // 热门服务
      hotServer: [
        {
          name: 'support.frequently_asked_question', //常见问题
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.spare_parts_repair_video', // 维修视频
          tips: 'support.service_spare_parts_repair_video',
          img: 'icon_video',
          iconPc: 'icon_video',
          openUrl: '',
          mUrl: '',
          buttonText: 'support.view_now',
          openType: OpenType.selfRepair,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.instruction', // 产品资料
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.apply_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.policy_detail', // 服务政策
          tips: 'support.query_product_policy',
          img: 'icon-policy-detail',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.policyDetail
        }
      ],
      // 锚点 
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      // 更多服务
      homeMoreServices: [
        {
          name: 'support.self_repair',//自助维修
          tips: 'support.self_repair_tips',
          img: 'ic_self_repair',
          iconPc: 'ic_self_repair',
          buttonText: 'support.view_now',
          openUrl: '/selfRepair',
          query: {
            goType: 3
          },
          mUrl: '/vehicleSupport/modelSelect',
          openType: OpenType.innerUrl,
          show: 1,
          businessType: BusinessType.selfRepair
        },
        // 序列号查询  自定义key 多语让填写excel生成
        {
          name: 'support.serial_number_title',//序列号查询
          tips: 'support.serial_number_detail',
          img: 'ic_service_number_m',
          iconPc: 'ic_service_number_pc',
          buttonText: 'support.serial_number_btn',
          openType: OpenType.link,
          openUrl: 'http://krservice.api.segway-ninebot.com/yataiyanzheng/',
          mUrl: 'http://krservice.api.segway-ninebot.com/yataiyanzheng/',
          show: 1
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',//保修政策
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          icon: 'icon-policy-detail-ver',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',//产品资源
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      // 维修指南
      vehicleRepair: [
        {
          name: 'vehicleSupport.self_repair',//自助维修
          tips: 'vehicleSupport.self_repair_tips',
          img: 'ic_self_repair_vehicle',
          iconPc: 'ic_self_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.selfRepair,
          openUrl: '',
          mUrl: '',
          show: 1
        },
      ],
      // 邮箱有在线客服没有-亚太通用
      onlineChat: {
        email: 'segway_apacme_service@ninebot.com'
      },
      adConfig: {
        test: {
          pcId: 'iwkDwX',
          mId: 'tA0Qut'
        },
        prod: {
          pcId: 'OwiDLI',
          mId: 'GBQPA3'
        },
        grey: {
          pcId: 'iwkDwX',
          mId: 'tA0Qut'
        }
      }
    },
    // 澳大利亚
    au: {
      lang: 'en',
      // 导航延用
      menu: [
        {
          name: 'Products',
          url: 'https://au.segway.com/',
          openType: OpenType.link
        },
        {
          name: 'About us',
          url: 'https://au.segway.com/about-us.html',
          openType: OpenType.link
        },
        {
          name: 'Find a dealer',
          url: 'https://au.segway.com/find-a-dealer.html',
          openType: OpenType.link
        },
        {
          name: 'Online store',
          url: 'https://www.segway.com.au/',
          openType: OpenType.link
        },
        // 分割线
        // 'content-divider',
        {
          name: 'Support',
          url: Support,
          openType: OpenType.backHome
        }
      ],
      // 热门服务
      hotServer: [
        {
          name: 'support.frequently_asked_question', //常见问题
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.spare_parts_repair_video', // 维修视频
          tips: 'support.service_spare_parts_repair_video',
          img: 'icon_video',
          iconPc: 'icon_video',
          openUrl: '',
          mUrl: '',
          buttonText: 'support.view_now',
          openType: OpenType.selfRepair,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.instruction', // 产品资料
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.apply_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.policy_detail', // 服务政策(保修政策)
          tips: 'support.query_product_policy',
          img: 'icon-policy-detail',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.policyDetail
        }
      ],
      // 锚点 
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      // 更多服务
      homeMoreServices: [
        {
          name: 'support.self_repair',//自助维修
          tips: 'support.self_repair_tips',
          img: 'ic_self_repair',
          iconPc: 'ic_self_repair',
          buttonText: 'support.view_now',
          openUrl: '/selfRepair',
          query: {
            goType: 3
          },
          mUrl: '/vehicleSupport/modelSelect',
          openType: OpenType.innerUrl,
          show: 1,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.service_network',//附近网点
          tips: 'support.service_network_info',
          img: 'ic_service_network_us',
          iconPc: 'ic_service_center',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: serviceCenter,
          mUrl: serviceCenter,
          show: 1
        },
        // 序列号查询   自定义key 多语让填写excel生成
        {
          name: 'support.serial_number_title',//序列号查询
          tips: 'support.serial_number_detail',
          img: 'ic_service_number_m',
          iconPc: 'ic_service_number_pc',
          buttonText: 'support.serial_number_btn',
          openType: OpenType.link,
          openUrl: 'http://krservice.api.segway-ninebot.com/yataiyanzheng/',
          mUrl: 'http://krservice.api.segway-ninebot.com/yataiyanzheng/',
          show: 1
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',//保修政策
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          icon: 'icon-policy-detail-ver',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',//产品资源
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      // 维修指南
      vehicleRepair: [
        {
          name: 'vehicleSupport.self_repair',//自助维修
          tips: 'vehicleSupport.self_repair_tips',
          img: 'ic_self_repair_vehicle',
          iconPc: 'ic_self_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.selfRepair,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.service_network',//服务网点
          tips: 'support.service_network_info',
          img: 'icon_sv_center',
          iconPc: 'ic_service_center',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: serviceCenter,
          mUrl: serviceCenter,
          show: 1
        },
        // {
        //   name: 'vehicleSupport.online_repair',//在线报修
        //   tips: 'vehicleSupport.online_repair_tips',
        //   img: 'ic_online_repair_vehicle',
        //   iconPc: 'ic_online_repair',
        //   buttonText: 'vehicleSupport.view_now',
        //   openType: OpenType.onlineRepair,
        //   openUrl: '/onlineRepair',
        //   mUrl: '/onlineRepair',
        //   show: 1
        // },
        // 视频专区是接口返回
        // {
        //   name: 'mailRepair.service_progress_check',//服务进度查询
        //   tips: 'mailRepair.service_check_progress',
        //   img: 'ic-m-mail-repair-progress',
        //   iconPc: 'ic-mail-repair-progress',
        //   buttonText: 'support.view_now',
        //   openUrl: '/mailRepair',
        //   mUrl: '/mailRepair',
        //   openType: OpenType.innerUrl,
        //   show: 1
        // }
      ],
      // 在线客服
      onlineChat: {
        email: 'service@segway.com.au',
        phone: '1800400009',
        phoneDesc: '1800400009',
        workTime: 'Monday–Friday 9:00–17:00 (AEDT)'
      },
      adConfig: {
        test: {
          pcId: '6QIElJ',
          mId: 'iKWVvz'
        },
        prod: {
          pcId: 'ZOrY47',
          mId: '0nAsxP'
        },
        grey: {
          pcId: '6QIElJ',
          mId: 'iKWVvz'
        }
      }
    },
    // 土耳其
    tr: {
      lang: 'tr',
      // 导航延用
      menu: [
        {
          name: 'Ürünler',
          url: 'https://turkey.segway.com/',
          openType: OpenType.link
        },
        {
          name: 'Hakkımızda',
          url: 'https://turkey.segway.com/about-us.html',
          openType: OpenType.link
        },
        {
          name: 'Nereden Satın Alınır',
          url: 'https://turkey.segway.com/find-a-dealer.html',
          openType: OpenType.link
        },
        // 分割线
        // 'content-divider',
        {
          name: 'Destek',
          url: Support,
          openType: OpenType.backHome
        }
      ],
      // 热门服务
      hotServer: [
        {
          name: 'support.frequently_asked_question', //常见问题
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.spare_parts_repair_video', // 维修视频
          tips: 'support.service_spare_parts_repair_video',
          img: 'icon_video',
          iconPc: 'icon_video',
          openUrl: '',
          mUrl: '',
          buttonText: 'support.view_now',
          openType: OpenType.selfRepair,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.instruction', // 产品资料
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.apply_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.policy_detail', // 服务政策
          tips: 'support.query_product_policy',
          img: 'icon-policy-detail',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.policyDetail
        }
      ],
      // 锚点 
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      // 更多服务
      homeMoreServices: [
        {
          name: 'support.self_repair',//自助维修
          tips: 'support.self_repair_tips',
          img: 'ic_self_repair',
          iconPc: 'ic_self_repair',
          buttonText: 'support.view_now',
          openUrl: '/selfRepair',
          query: {
            goType: 3
          },
          mUrl: '/vehicleSupport/modelSelect',
          openType: OpenType.innerUrl,
          show: 1,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.service_network',//附近网点
          tips: 'support.service_network_info',
          img: 'ic_service_network_us',
          iconPc: 'ic_service_center',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: serviceCenter,
          mUrl: serviceCenter,
          show: 1
        },
        // 序列号查询   自定义key 多语让填写excel生成
        {
          name: 'support.serial_number_title',//序列号查询
          tips: 'support.serial_number_detail',
          img: 'ic_service_number_m',
          iconPc: 'ic_service_number_pc',
          buttonText: 'support.serial_number_btn',
          openType: OpenType.link,
          openUrl: 'http://krservice.api.segway-ninebot.com/yataiyanzheng/',
          mUrl: 'http://krservice.api.segway-ninebot.com/yataiyanzheng/',
          show: 1
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',//保修政策
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          icon: 'icon-policy-detail-ver',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',//产品资源
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      // 维修指南
      vehicleRepair: [
        {
          name: 'vehicleSupport.self_repair',//自助维修
          tips: 'vehicleSupport.self_repair_tips',
          img: 'ic_self_repair_vehicle',
          iconPc: 'ic_self_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.selfRepair,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.service_network',//服务网点
          tips: 'support.service_network_info',
          img: 'icon_sv_center',
          iconPc: 'ic_service_center',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: serviceCenter,
          mUrl: serviceCenter,
          show: 1
        },
      ],
      // 在线客服
      onlineChat: {
        email: 'segway@ktsteknikservis.com',
        phone: '+90 444 8139',
        phoneDesc: '+90 444 8139',
        workTime: 'Pazartesi–Cuma 9:00–17:00 (TRT)'
      },
      adConfig: {
        test: {
          pcId: '6u4hHS',
          mId: 'b6Dfmw'
        },
        prod: {
          pcId: 'FKPvKy',
          mId: 'r3CDe1'
        },
        grey: {
          pcId: '6u4hHS',
          mId: 'b6Dfmw'
        }
      }
    },
    // 俄罗斯
    ru: {
      lang: 'ru',
      // 导航延用
      menu: [
        {
          name: 'Продукты',
          url: 'https://ru.segway.com/',
          openType: OpenType.link
        },
        {
          name: 'О нас',
          url: 'https://ru.segway.com/about-us.html',
          openType: OpenType.link
        },
        {
          name: 'Где купитьr',
          url: 'https://ru.segway.com/find-a-dealer.html',
          openType: OpenType.link
        },
        // 分割线
        // 'content-divider',
        {
          name: 'Поддержка',
          url: Support,
          openType: OpenType.backHome
        }
      ],
      // 热门服务
      hotServer: [
        {
          name: 'support.frequently_asked_question', //常见问题
          tips: 'support.faqs_general',
          img: 'ic_frequently_asked_question',
          iconPc: 'ic_FAQ',
          openUrl: '/vehicleSupport/productSelect',
          mUrl: '/vehicleSupport/productSelect',
          buttonText: 'support.view_now',
          openType: OpenType.selfInspectManual,
          businessType: BusinessType.FAQ
        },
        {
          name: 'support.spare_parts_repair_video', // 维修视频
          tips: 'support.service_spare_parts_repair_video',
          img: 'icon_video',
          iconPc: 'icon_video',
          openUrl: '',
          mUrl: '',
          buttonText: 'support.view_now',
          openType: OpenType.selfRepair,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.instruction', // 产品资料
          tips: 'support.query_product_parameter',
          img: 'icon-instructions-home',
          iconPc: 'icon-instructions',
          buttonText: 'support.apply_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.instruction
        },
        {
          name: 'support.policy_detail', // 服务政策
          tips: 'support.query_product_policy',
          img: 'icon-policy-detail',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          businessType: BusinessType.policyDetail
        }
      ],
      // 锚点 
      vehicleAnchor: [
        {
          name: 'vehicleSupport.anchor_faqs',
          show: 1,
          type: 'faqs',
          className: 'book-con'
        },
        {
          name: 'vehicleSupport.anchor_repair',
          show: 1,
          type: 'repair',
          className: 'repair-con'
        },
        {
          name: 'vehicleSupport.anchor_doc',
          show: 1,
          type: 'doc',
          className: 'doc-con'
        },
        {
          name: 'vehicleSupport.anchor_tutorial',
          show: 1,
          type: 'video',
          className: 'video-con'
        },
        {
          name: 'vehicleSupport.anchor_more',
          show: 1,
          type: 'more',
          className: 'more-con'
        }
      ],
      // 更多服务
      homeMoreServices: [
        {
          name: 'support.self_repair',//自助维修
          tips: 'support.self_repair_tips',
          img: 'ic_self_repair',
          iconPc: 'ic_self_repair',
          buttonText: 'support.view_now',
          openUrl: '/selfRepair',
          query: {
            goType: 3
          },
          mUrl: '/vehicleSupport/modelSelect',
          openType: OpenType.innerUrl,
          show: 1,
          businessType: BusinessType.selfRepair
        },
        {
          name: 'support.service_network',//附近网点
          tips: 'support.service_network_info',
          img: 'ic_service_network_us',
          iconPc: 'ic_service_center',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: serviceCenter,
          mUrl: serviceCenter,
          show: 1
        },
        // 序列号查询   自定义key 多语让填写excel生成
        {
          name: 'support.serial_number_title',//序列号查询
          tips: 'support.serial_number_detail',
          img: 'ic_service_number_m',
          iconPc: 'ic_service_number_pc',
          buttonText: 'support.serial_number_btn',
          openType: OpenType.link,
          openUrl: 'http://krservice.api.segway-ninebot.com/yataiyanzheng/',
          mUrl: 'http://krservice.api.segway-ninebot.com/yataiyanzheng/',
          show: 1
        }
      ],
      // 文档
      vehicleDoc: [
        {
          name: 'support.policy_detail',//保修政策
          tips: 'support.query_product_policy',
          img: 'ic-policy-detail-vehicle',
          icon: 'icon-policy-detail-ver',
          iconPc: 'icon-policy-detail',
          buttonText: 'support.view_now',
          openType: OpenType.policyDetail,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.instruction',//产品资源
          tips: 'support.query_product_parameter',
          img: 'ic-instructions-vehicle',
          iconPc: 'icon-instructions',
          buttonText: 'support.view_now',
          openType: OpenType.instructions,
          openUrl: '',
          mUrl: '',
          show: 1
        }
      ],
      // 维修指南
      vehicleRepair: [
        {
          name: 'vehicleSupport.self_repair',//自助维修
          tips: 'vehicleSupport.self_repair_tips',
          img: 'ic_self_repair_vehicle',
          iconPc: 'ic_self_repair',
          buttonText: 'vehicleSupport.view_now',
          openType: OpenType.selfRepair,
          openUrl: '',
          mUrl: '',
          show: 1
        },
        {
          name: 'support.service_network',//服务网点
          tips: 'support.service_network_info',
          img: 'icon_sv_center',
          iconPc: 'ic_service_center',
          buttonText: 'support.view_now',
          openType: OpenType.innerUrl,
          openUrl: serviceCenter,
          mUrl: serviceCenter,
          show: 1
        },
      ],
      // 在线客服
      onlineChat: {
        email: 'info@4tservice.ru',
        phone: '+7 8003505223',
        phoneDesc: '+7 8003505223',
        workTime: 'Обслуживание 24/7'
      },
      adConfig: {
        test: {
          pcId: 'pTY3Se',
          mId: 'dE1jm7'
        },
        prod: {
          pcId: 'GjCneb',
          mId: 'P0o2rt'
        },
        grey: {
          pcId: 'pTY3Se',
          mId: 'dE1jm7'
        }
      }
    },
  };

  const data: any = getSiteList();
  const countries = data.map((item: any) => item.country);

  if (countries.includes(country)) return config[country];
  if (REGION_MODE === 'cn') return config['cn'];
  return config['us'];
}

// serviceCenter(服务网点)页面 新增澳大利亚,土耳其,俄罗斯
export function getServerCenter() {
  const config: any = {
    us: {
      urlTipsData: [
        {
          text: 'selfRepair.frequently_asked_question',
          h5Url: '/vehicleSupport/seriesSelect',
          url: '/product/seriesSelect',
          query: {
            goType: 2
          },
          openType: 'innerUrl',
          clickType: '常见问题'
        }, //常见问题
        {
          text: 'serviceOutlets.online_service',
          h5Url: 'https://dms-cc-us.segway-ninebot.com/chat_core/chatpage.html',
          url: 'https://dms-cc-us.segway-ninebot.com/chat_core/chatpage.html',
          openType: 'link',
          clickType: '在线客服',
        }, //在线客服
        {
          text: 'selfRepair.self_repair',
          h5Url: '/vehicleSupport/modelSelect',
          url: '/selfRepair',
          query: {
            goType: 3
          },
          openType: 'innerUrl',
          clickType: '自助维修'
        }, //自助维修
        {
          text: 'serviceOutlets.send_repair_tips',
          h5Url: '/onlineRepair',
          url: '/onlineRepair',
          query: {},
          openType: 'innerUrl',
          clickType: '寄修服务'
        }
      ]
    },
    au: {
      urlTipsData: [
        {
          text: 'selfRepair.frequently_asked_question',
          h5Url: '/vehicleSupport/seriesSelect',
          url: '/product/seriesSelect',
          query: {
            goType: 2
          },
          openType: 'innerUrl',
          clickType: '常见问题'
        }, //常见问题
        {
          text: 'serviceOutlets.online_service_au',
          h5Url: 'https://au.segway.com/contact.html',
          url: 'https://au.segway.com/contact.html',
          openType: 'link',
          clickType: '在线客服',
        }, //在线客服
        {
          text: 'selfRepair.self_repair',
          h5Url: '/vehicleSupport/modelSelect',
          url: '/selfRepair',
          query: {
            goType: 3
          },
          openType: 'innerUrl',
          clickType: '自助维修'
        }, //自助维修
      ]

    },
    tr: {
      urlTipsData: [
        {
          text: 'selfRepair.frequently_asked_question',
          h5Url: '/vehicleSupport/seriesSelect',
          url: '/product/seriesSelect',
          query: {
            goType: 2
          },
          openType: 'innerUrl',
          clickType: '常见问题'
        }, //常见问题
        {
          text: 'serviceOutlets.online_service',
          h5Url: 'https://turkey.segway.com/contact.html',
          url: 'https://turkey.segway.com/contact.html',
          openType: 'link',
          clickType: '在线客服',
        }, //在线客服
        {
          text: 'selfRepair.self_repair',
          h5Url: '/vehicleSupport/modelSelect',
          url: '/selfRepair',
          query: {
            goType: 3
          },
          openType: 'innerUrl',
          clickType: '自助维修'
        }, //自助维修
      ]
    },
    ru: {
      urlTipsData: [
        {
          text: 'selfRepair.frequently_asked_question',
          h5Url: '/vehicleSupport/seriesSelect',
          url: '/product/seriesSelect',
          query: {
            goType: 2
          },
          openType: 'innerUrl',
          clickType: '常见问题'
        }, //常见问题
        {
          text: 'selfRepair.self_repair',
          h5Url: '/vehicleSupport/modelSelect',
          url: '/selfRepair',
          query: {
            goType: 3
          },
          openType: 'innerUrl',
          clickType: '自助维修'
        }, //自助维修
      ]
    }
  }
  const data: any = getSiteList();
  const countries = data.map((item: any) => item.country);

  if (countries.includes(environmentData.country)) return config[environmentData.country]?.urlTipsData;
  return config['us']?.urlTipsData;
}
export const urlTipsData = [
  {
    text: 'selfRepair.frequently_asked_question',
    h5Url: '/vehicleSupport/seriesSelect',
    url: '/product/seriesSelect',
    query: {
      goType: 2
    },
    openType: 'innerUrl',
    clickType: '常见问题'
  }, //常见问题
  {
    text: 'serviceOutlets.online_service',
    h5Url: 'https://dms-cc-us.segway-ninebot.com/chat_core/chatpage.html',
    url: 'https://dms-cc-us.segway-ninebot.com/chat_core/chatpage.html',
    openType: 'link',
    clickType: '在线客服',
  }, //在线客服
  {
    text: 'selfRepair.self_repair',
    h5Url: '/vehicleSupport/modelSelect',
    url: '/selfRepair',
    query: {
      goType: 3
    },
    openType: 'innerUrl',
    clickType: '自助维修'
  }, //自助维修
  {
    text: 'serviceOutlets.send_repair_tips',
    h5Url: '/onlineRepair',
    url: '/onlineRepair',
    query: {},
    openType: 'innerUrl',
    clickType: '寄修服务'
  }
]; //寄修服务

export const processArr = [
  {
    title: 'online_info_register',
    icon: 'ic_register'
  },
  {
    title: 'shipment_product',
    icon: 'ic_shipment'
  },
  {
    title: 'repair_completed_return',
    icon: 'ic_returned'
  },
  {
    title: 'repair_process',
    icon: 'ic_processing'
  }
];

export const processArrForPC = [
  {
    title: 'online_info_register',
    icon: 'ic_register'
  },
  {
    title: 'shipment_product',
    icon: 'ic_shipment'
  },
  {
    title: 'repair_process',
    icon: 'ic_processing'
  },
  {
    title: 'repair_completed_return',
    icon: 'ic_returned'
  }
];
